<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        
        :collapse="isCollapse"
        background-color="#2196f3"
        text-color="#fff"
        active-text-color="#409EFF"
        :unique-opened="true"
        :collapse-transition="false"
        mode="vertical"
        ref="compMenu"
        
      >
        <sidebar-item
          v-for="route in permission_routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
//import variables from '@/assets/styles/variables.scss'

export default {
  data(){
    return {
      selectIndex:''
    }
  },
  components: { SidebarItem, Logo },
  computed: {
    ...mapGetters(["permission_routes", "sidebar"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return  path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    // variables() {
    //   return variables
    // },
    isCollapse() {
      return !this.sidebar.opened;
    }
  },
  // watch:{
  //   '$store.getters.saveData'(){
  //     if(!this.$store.getters.saveData) {
  //       document.querySelectorAll(".el-menu-item").forEach(item=>{
  //         debugger
  //         item.classList.remove('is-active');
  //       })
  //     }
  //   }
  // },
  // methods: {
  //   selectEvent(index,indexPath,$event) {
  //     if(!this.$store.getters.saveData) {
  //       debugger
  //       this.selectIndex = '/scheme/design';
  //     }

  //   }
  // }
};
</script>
